import { takeEveryFsa } from "../operations";
import { accountActions } from "./actions";
import { changePasswordApi } from "../../core/http/httpClient";
import { makeAsyncApiCall } from "../common";

export function* accountSaga() {
    yield takeEveryFsa(accountActions.changePassword.started, function* (action) {
        yield* makeAsyncApiCall(action, accountActions.changePassword, changePasswordApi);
    });
} 